import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import SelectableButtonComponent from '../../../../components/selectable-button';

export const VariantGroupWrapper = styled.div`
  padding-left: 2px;
`;

export const VariantGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 2px;

  ${media.smallOnly`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: ${layout.measurements.spacingSmall};
    margin: 0;
    padding: 0;
    padding-bottom: 2px;
  `}
`;

type SelectableButtonProps = {
  selected: boolean;
};

export const SelectableButton = styled(SelectableButtonComponent)<
  SelectableButtonProps
>`
  display: flex;
  min-width: 125px;
  min-height: 53px;

  ${media.smallOnly`
    margin-right: 0;
  `}
`;
